// extracted by mini-css-extract-plugin
export default {"tagsSection":"TagsSection-module__tagsSection--G5YQC","categories":"TagsSection-module__categories--NskLE"};